// StrengthStats.js
import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { primaryColor } from "../../../../Constants/Colors";
import { useGetStatsDataQuery } from "../../../../redux/api/StatsApi/statsApi";

const StrengthStats = () => {
  const { data, isLoading } = useGetStatsDataQuery({
    limit: 1,
    sortBy: "display_order",
    order: "asc",
  });

  const activeStats = data?.stats?.find((s) => s.status);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!activeStats) return null;

  return (
    <div style={{ padding: "50px 0", backgroundColor: "#fff" }}>
      <Container>
        <Row className="align-items-center">
          {/* Left Column */}
          <Col md={6}>
            <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>
              {activeStats.title}
            </h2>
            <p className="text-muted mt-3">{activeStats.description}</p>
          </Col>

          {/* Right Column - 2x2 Grid */}
          <Col md={6}>
            <Row>
              {/* Top Left */}
              <Col
                xs={6}
                className="text-center py-4"
                style={{
                  borderRight: `1px solid ${primaryColor}`,
                  borderBottom: `1px solid ${primaryColor}`,
                }}
              >
                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>
                  {activeStats.stat_one_value}
                </h2>
                <p className="text-muted mb-0">{activeStats.stat_one_title}</p>
              </Col>

              {/* Top Right */}
              <Col
                xs={6}
                className="text-center py-4"
                style={{
                  borderBottom: `1px solid ${primaryColor}`,
                }}
              >
                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>
                  {activeStats.stat_two_value}
                </h2>
                <p className="text-muted mb-0">{activeStats.stat_two_title}</p>
              </Col>

              {/* Bottom Left */}
              <Col
                xs={6}
                className="text-center py-4"
                style={{
                  borderRight: `1px solid ${primaryColor}`,
                }}
              >
                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>
                  {activeStats.stat_three_value}
                </h2>
                <p className="text-muted mb-0">
                  {activeStats.stat_three_title}
                </p>
              </Col>

              {/* Bottom Right */}
              <Col xs={6} className="text-center py-4">
                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>
                  {activeStats.stat_four_value}
                </h2>
                <p className="text-muted mb-0">{activeStats.stat_four_title}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StrengthStats;
